"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _STRtree = _interopRequireDefault(require("../../index/strtree/STRtree"));

var _IsValidOp = _interopRequireDefault(require("./IsValidOp"));

var _PointLocation = _interopRequireDefault(require("../../algorithm/PointLocation"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Envelope = _interopRequireDefault(require("../../geom/Envelope"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var IndexedNestedRingTester =
/*#__PURE__*/
function () {
  function IndexedNestedRingTester() {
    _classCallCheck(this, IndexedNestedRingTester);

    IndexedNestedRingTester.constructor_.apply(this, arguments);
  }

  _createClass(IndexedNestedRingTester, [{
    key: "buildIndex",
    value: function buildIndex() {
      this._index = new _STRtree.default();

      for (var i = 0; i < this._rings.size(); i++) {
        var ring = this._rings.get(i);

        var env = ring.getEnvelopeInternal();

        this._index.insert(env, ring);
      }
    }
  }, {
    key: "getNestedPoint",
    value: function getNestedPoint() {
      return this._nestedPt;
    }
  }, {
    key: "isNonNested",
    value: function isNonNested() {
      this.buildIndex();

      for (var i = 0; i < this._rings.size(); i++) {
        var innerRing = this._rings.get(i);

        var innerRingPts = innerRing.getCoordinates();

        var results = this._index.query(innerRing.getEnvelopeInternal());

        for (var j = 0; j < results.size(); j++) {
          var searchRing = results.get(j);
          var searchRingPts = searchRing.getCoordinates();
          if (innerRing === searchRing) continue;
          if (!innerRing.getEnvelopeInternal().intersects(searchRing.getEnvelopeInternal())) continue;

          var innerRingPt = _IsValidOp.default.findPtNotNode(innerRingPts, searchRing, this._graph);

          if (innerRingPt === null) continue;

          var isInside = _PointLocation.default.isInRing(innerRingPt, searchRingPts);

          if (isInside) {
            this._nestedPt = innerRingPt;
            return false;
          }
        }
      }

      return true;
    }
  }, {
    key: "add",
    value: function add(ring) {
      this._rings.add(ring);

      this._totalEnv.expandToInclude(ring.getEnvelopeInternal());
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IndexedNestedRingTester;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return IndexedNestedRingTester;
}();

exports.default = IndexedNestedRingTester;

IndexedNestedRingTester.constructor_ = function () {
  this._graph = null;
  this._rings = new _ArrayList.default();
  this._totalEnv = new _Envelope.default();
  this._index = null;
  this._nestedPt = null;
  var graph = arguments[0];
  this._graph = graph;
};